import React from 'react';
import {Stage} from '../Stage';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';

type NoActionStageProps = {
    id: string,
    period: string,
    title: string,
    description: string,
}

export const NoActionStage = (props: NoActionStageProps) => {
    const {id, period, title, description} = props

    return (
        <Stage
            expanded={true}
            icon={<AccessTimeIcon color="warning"/>}
            id={id}
            subTitle={period}
            title={title}
        >
            <Typography>
                {description}
            </Typography>
        </Stage>
    )
}
